<app-c2c-order-details [data]="receiverDetails"></app-c2c-order-details>
